module.exports = (__webpack_require__(2))("./core/framework/loader.js");


//////////////////
// WEBPACK FOOTER
// delegated ./core/framework/loader.js from dll-reference base
// module id = 96
// module chunks = 22